/**
 * Infinite Loop Carousel for element with id "hotspot--carousel"
 * 
 * Usage:
 * - The carousel container should have id "hotspot--carousel"
 * - The direct children of the container are considered slides
 * - This script creates next and previous buttons automatically
 */

document.addEventListener('DOMContentLoaded', function () {
  var carousel = document.getElementById('hotspot--carousel');
  var carouselBtn = document.getElementById('hotspot--carousel-btn');
  if (!carousel) {
    console.error('Carousel element with id "hotspot--carousel" not found.');
    return;
  }

  /** @type {HTMLElement[]} */
  var slides = Array.from(carousel.children).filter(function(el) {
    return el instanceof HTMLElement;
  });
  if (slides.length === 0) {
    console.warn('No slides found inside the carousel.');
    return;
  }

  // Create a wrapper div to hold slides and enable sliding
  var wrapper = document.createElement('div');
  wrapper.classList.add('carousel-wrapper');
  wrapper.style.display = 'flex';
  wrapper.style.transition = 'transform 0.4s ease-in-out';
  wrapper.style.willChange = 'transform';

  // Move slides into wrapper
  slides.forEach(function (slide) {
    slide.style.flex = '0 0 100%';
    wrapper.appendChild(slide);
  });

  // Clear original carousel and append wrapper
  carousel.innerHTML = '';
  carousel.style.overflow = 'hidden';
  carousel.style.position = 'relative';
  carousel.appendChild(wrapper);

  // Clone first and last slides for infinite effect
  var firstClone = slides[0] && slides[0].cloneNode(true);
  var lastClone = slides[slides.length - 1] && slides[slides.length - 1].cloneNode(true);
  if (firstClone) wrapper.appendChild(firstClone);
  if (lastClone) wrapper.insertBefore(lastClone, wrapper.firstChild);

  var currentIndex = 1; // Start at first real slide (after lastClone)
  var slideCount = slides.length;

  // Set initial position
  var updatePosition = function () {
    wrapper.style.transform = 'translateX(-' + currentIndex * 100 + '%)';
  };
  updatePosition();

  /**
   * @param {string} className
   * @param {string} svgContent
   */
  var createButton = function (className, svgContent) {
    var btn = document.createElement('button');
    btn.className = className;
    btn.style.position = 'absolute';
    btn.style.top = '50%';
    btn.style.color = 'black';
    btn.style.background = 'transparent';
    btn.style.border = 'none';
    btn.style.padding = '0 10px';
    btn.style.cursor = 'pointer';
    btn.style.zIndex = '10';
    btn.style.fontSize = '30px';
    btn.innerHTML = svgContent;
    return btn;
  };

  var arrowSvg = '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M10 15L20 25L30 15" stroke="#868A96" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var prevButton = createButton('carousel-prev', arrowSvg);
  prevButton.style.left = '-35px';
  prevButton.style.transform = 'translateY(-50%) rotate(90deg)';

  var nextButton = createButton('carousel-next', arrowSvg);
  nextButton.style.right = '-35px';
  nextButton.style.transform = 'translateY(-50%) rotate(270deg)';

  if (carouselBtn) {
    carouselBtn.appendChild(prevButton);
    carouselBtn.appendChild(nextButton);
  }

  // Disable transition temporarily
  var disableTransition = function () {
    wrapper.style.transition = 'none';
  };

  // Enable transition
  var enableTransition = function () {
    wrapper.style.transition = 'transform 0.4s ease-in-out';
  };

  // Handle transition end for infinite loop effect
  wrapper.addEventListener('transitionend', function () {
    if (currentIndex === 0) {
      disableTransition();
      currentIndex = slideCount;
      updatePosition();
      // Force reflow to apply transform without transition
      wrapper.offsetHeight;
      enableTransition();
    } else if (currentIndex === slideCount + 1) {
      disableTransition();
      currentIndex = 1;
      updatePosition();
      wrapper.offsetHeight;
      enableTransition();
    }
  });

  // Navigation button handlers
  prevButton.addEventListener('click', function () {
    if (currentIndex <= 0) return;
    currentIndex--;
    updatePosition();
  });

  nextButton.addEventListener('click', function () {
    if (currentIndex >= slideCount + 1) return;
    currentIndex++;
    updatePosition();
  });

  // Swipe support variables
  var startX = 0;
  var currentX = 0;
  var isDragging = false;
  var threshold = 50; // Minimum px to consider swipe

  // Touch start event
  wrapper.addEventListener('touchstart', function (e) {
    if (e.touches.length === 1) {
      startX = e.touches[0].clientX;
      isDragging = true;
      disableTransition();
    }
  });

  // Touch move event
  wrapper.addEventListener('touchmove', function (e) {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;
    var deltaX = currentX - startX;
    // Move wrapper along with finger
    wrapper.style.transform = 'translateX(' + (-currentIndex * 100 + (deltaX / wrapper.offsetWidth) * 100) + '%)';
    e.preventDefault(); // Prevent horizontal scroll
  }, { passive: false });

  // Touch end event
  wrapper.addEventListener('touchend', function (e) {
    if (!isDragging) return;
    isDragging = false;
    enableTransition();
    var deltaX = currentX - startX;
    if (Math.abs(deltaX) > threshold) {
      if (deltaX > 0) {
        // Swipe right - previous slide
        if (currentIndex > 0) {
          currentIndex--;
        }
      } else {
        // Swipe left - next slide
        if (currentIndex < slideCount + 1) {
          currentIndex++;
        }
      }
    }
    updatePosition();
  });

});
